import { DataSource } from "@angular/cdk/table";
import { CollectionViewer } from "@angular/cdk/collections";
import { Observable, Subscription, ReplaySubject } from "rxjs";
import { GeneralDataService } from "../../services/general-data.service";
import { DataFilter } from "../../models/data-filter-model";
import { NgxSpinnerService } from "ngx-spinner";

export class DashboardDataSource extends DataSource<string> {
  filters: DataFilter;
  totalCount;
  serviceResult;
  isLoaded = false;
  start: number;
  end: number;
  supplierName: string;
  IsWait;
  private readonly subscription = new Subscription();
  private readonly datastream = new ReplaySubject<string[]>();

  private listSubscription: Subscription;
  constructor(
    private readonly generalService: GeneralDataService,
    private readonly spinner: NgxSpinnerService
  ) {
    super();
    this.getDetails("initial");
  }

  connect(
    collectionViewer: CollectionViewer
  ): Observable<string[] | readonly string[]> {
    this.subscription.add(
      collectionViewer.viewChange.subscribe((range) => {
        if (range.end > range.start && range.end >= this.serviceResult.length) {
          if (range.end < this.totalCount) {
            this.start = this.serviceResult.length;
            if (this.totalCount - this.serviceResult.length <= 20) {
              this.end = this.totalCount - 1;
            } else {
              this.end = this.start + 19;
            }
            this.getDetails();
          }
        }
      })
    );
    return this.datastream;
  }
  disconnect(collectionViewer: CollectionViewer): void {
    this.subscription.unsubscribe();
  }

  getDetails(state?: string, searchSupplier?: string) {
    this.spinner.show();
    this.isLoaded = false;
    if (state && state === "initial") {
      this.start = 0;
      this.end = 29;
      if (this.serviceResult) {
        this.serviceResult.length = 0;
      }
      if (searchSupplier) {
        this.supplierName = searchSupplier
          ? searchSupplier.trim()
          : searchSupplier;
      } else {
        this.supplierName = null;
      }

      this.IsWait = false;
    }
    this.getGeneralData();
  }

  private getGeneralData() {
    this.listSubscription = this.generalService
      .getGeneralData(this.start, this.end, this.supplierName)
      .subscribe(
        (data: any) => {
          if (data) {
            let result = [];
            this.totalCount = data.totalCount;
            if (this.serviceResult && this.serviceResult.length > 0) {
              result = [...this.serviceResult, ...data.result];
            } else {
              result = [...data.result];
            }
            this.serviceResult = result;
            this.datastream.next(result);
            this.isLoaded = true;
            this.spinner.hide();
          }
        },
        (error) => {
          this.serviceResult = [];
          this.serviceResult.length = 0;
          this.datastream.next(this.serviceResult);
          this.spinner.hide();
          this.isLoaded = true;
        }
      );
  }

  onDestroy() {
    this.listSubscription.unsubscribe();
  }
}
